import { Expose, Type } from 'class-transformer';
import { Point } from 'geojson';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { SnPlateDetail } from './plates-details';

export class SnPlate extends SnModel {
  @Expose()
  public confidence: number;

  @Expose() public createdTimestamp: Date;

  @Expose() public eventTimestamp: Date;

  @Expose()
  @ExposeRawData()
  public geometry: Point;

  @Expose()
  @Type(() => SnPlateDetail)
  public details: SnPlateDetail;

  @Expose()
  public id: string;

  @Expose()
  public overviewImageUrl: string;

  @Expose()
  public plate: string;

  @Expose()
  public plateImageUrl: string;

  @Expose()
  public type: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
